module.exports = __webpack_public_path__ + "img/transactions.dd6d16c6.svg";